var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfigurationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9844 1.66667L14.9844 7.5",
    stroke: "#717C90",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9844 15.833L14.9844 18.333",
    stroke: "#717C90",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82031 1.66699L5.82031 4.16699",
    stroke: "#717C90",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82031 12.4997L5.82031 18.333",
    stroke: "#717C90",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4844 14.1663L12.4844 9.16634C12.4844 8.24967 12.901 7.49967 14.151 7.49967L15.8177 7.49967C17.0677 7.49967 17.4844 8.24967 17.4844 9.16634L17.4844 14.1663C17.4844 15.083 17.0677 15.833 15.8177 15.833L14.151 15.833C12.901 15.833 12.4844 15.083 12.4844 14.1663Z",
    stroke: "#717C90",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32031 10.8333L3.32031 5.83333C3.32031 4.91667 3.73698 4.16667 4.98698 4.16667L6.65365 4.16667C7.90365 4.16667 8.32031 4.91667 8.32031 5.83333L8.32031 10.8333C8.32031 11.75 7.90365 12.5 6.65365 12.5L4.98698 12.5C3.73698 12.5 3.32031 11.75 3.32031 10.8333Z",
    stroke: "#717C90",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigurationsIcon);
export default __webpack_public_path__ + "static/media/configurationsIcon.ad0990f87639adb9bd73a11ca47bc58c.svg";
export { ForwardRef as ReactComponent };